module.exports = __webpack_public_path__ + "img/s_p_s_mu.fe3cd13a.jpg";